import { connect } from "react-redux";
import RmListReport from "./rmListReport";
import { bindActionCreators } from "redux";
import {fetchRmTicketReport, getRmTicketsFilterDropDown} from "services/redux/maintenance/rmTicket/action";
const mapStateToProps = (state) => ({
    rmTicket: state.rmTicketReducer.rmTicketReport,
    rmTicketFilter: state.rmTicketReducer.rmTicketFilter
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchRmTicketReport,
        getRmTicketsFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RmListReport);
